const textEstado = (estado) => {
  switch (estado) {
    case '0':
      return "Sin Procesar";
    case '1':
      return "pendiente DIAN";
    case '2':
      return "Exitoso Dian";
    case '3':
      return "Errores Dian";
    case '4':
      return "Correo Enviado";
    case '5':
      return "Requiere Aprobacion";
    case '6':
      return "Error Enviando Correo";
    default:
      return "Contactar a soporte ";
  }
}

const textEstadoTurno = (estado) => {
  estado = estado.toString();
  switch (estado) {
    case "0":
      return "Cerrado";
    case "1":
      return "Abierto";
    default:
      return "Contactar a soporte ";
  }
}

const textEstadoGeneral = (estado) => {
  estado = (estado) ? estado.toString() : "0";
  switch (estado) {
    case "0":
      return "Inactivo";
    case "1":
      return "Activo";
    default:
      return "Contactar a soporte ";
  }
}

const textCut = (cadena) => {
  if (cadena.length > 25) {
    cadena = cadena.substring(0, 25) + "..."
  }
  return cadena;
}

const formatDate = (cadena) => {
  if (cadena) {
    const text = cadena.toString();
    const format = text.substring(0, 10);
    return format;
  } else {
    return "0000-00-00"
  }

}

const limpiarArray = (array) => {
  const cleanArray = array.filter(function () { return true });
  return cleanArray;
}

const limpiezaCaracter = (cadena, caracteres) => {
  let newcadena = cadena;
  newcadena = newcadena.split(",").join(";");
  caracteres.forEach(element => {
    newcadena = newcadena.split(element).join("");
  });
  return newcadena;
}

const round = (valor, decimal)=>{
  let convertNumber = 0;
  const exponente =  Math.pow( 10, decimal);
  convertNumber = valor * exponente;
  convertNumber = Math.round(convertNumber);
  convertNumber /= exponente;
  return convertNumber;
}

const homologacionDescription = (code)=>{
  const validacion = {
    '01':'HED',
    '02':'HEN',
    '03':'HRN',
    '04':'HEDDF',
    '05':'HRDDF',
    '06':'HENDF',
    '07':'HRNDF',
    '08':'VACACIONES',
    '09':'LICENCIA PATERNIDAD/MATERNIDAD',
    '10':'LINCENCIA REMUNERADA',
    '11':'LINCENCIA NO REMUNERADA',
    '12':'OTRO DEVENGADO',
    '13':'PRIMA',
    '14-1':'INCAPACIDAD COMUN',
    '14-2':'INCAPACIDAD PROFESIONAL',
    '14-3':'INCAPACIDAD LABORAL',
    '18':'SUELDO',
    '19':'CESANTIAS',
    '22':'AUXILIO TRANSPORTE',
    '23':'INTERESES CESANTIAS',
    '24':'BONIFICACIONES SALARIALES',
    '25':'BONIFICACIONES NO SALARIALES',
    '26':'AUXILIOS SALARIALES',
    '27':'AUXILIOS NO SALARIALES',
    '28':'HUELGAS LEGALES',
    '29':'COMPENSACIONES',
    '30':'COMISIONES',
    '31':'PAGOS_TERCEROS',
    '32':'ANTICIPOS',
    '33':'DOTACION',
    '34':'APOYO',
    '35':'TELETRABAJO',
    '36':'BONIFICACION_RETIRO',
    '37':'INDEMNIZACION',
    '38':'REINTEGRO',
    '15':'LIBRANZA',
    '16':'ANTICIPO',
    '17':'OTRAS DEDUCC',
    '20':'EPS',
    '21':'PENSION',
    '39':'SINDICATOS',
    '40':'SANCIONES PUBLICA',
    '41':'SANCIONES',
    '42':'PAGOS_TERCEROS',
    '43':'PENSION_VOLUNTARIA',
    '44':'RETENCION_FUENTE',
    '45':'AFC',
    '46':'COOPERATIVA',
    '47':'EMBARGO_FISCAL',
    '48':'PLAN_COMPLEMENTARIOS',
    '49':'EDUCACION',
    '50':'REINTEGRO',
    '51':'DEUDA'    
}

  return (validacion[code] || "Descripcion pendiente");
}

const estadosPedidos = (code)=>{
  const validacion = {
  "0":"Registrado",
  "1":"Procesado",
  "2":"Facturado",
  "7":"Pendiente Aprobacion",
  }

  return (validacion[code] || "xxxxxx");
}

const funciones = {
  textEstado,
  textCut,
  limpiarArray,
  formatDate,
  textEstadoTurno,
  textEstadoGeneral,
  limpiezaCaracter,
  round,
  homologacionDescription,
  estadosPedidos
}

export default funciones;


// WEBPACK FOOTER //
// ./src/middleware/funciones.js